import { reconcileDisabilityMap } from './reconcile-disability-map';
import { makeSchemaForPOWDisabilities } from './schemas';
import { isClaimingNew } from './index';

/**
 * Helper to get POW disability IDs as an array
 * @param {Object} formData - The form data
 * @returns {string[]} Array of POW disability IDs (in sippableId format)
 */
const getCurrentPOWDisabilityIdArray = formData => {
  if (!isClaimingNew(formData)) return [];
  const schema = makeSchemaForPOWDisabilities(formData);
  return Object.keys(schema.properties || {});
};

/**
 * Reconciles view:isPow.powDisabilities by removing entries for disabilities that
 * no longer exist in the current condition list, and migrates values for renames.
 *
 * This handles the case where a user changes a condition's sideOfBody value
 * (e.g. LEFT → RIGHT), which produces a new sippableId key. The rename migration
 * ensures that the old key (e.g. 'anklesprainleft') is migrated to the new key
 * (e.g. 'anklesprainright') instead of being lost.
 *
 * @param {Object|undefined} oldFormData - Previous form data (for rename detection, optional)
 * @param {Object} newFormData - The form data to update
 * @returns {Object} Updated form data with synced powDisabilities
 */
export const reconcilePowDisabilities = (
  oldFormData = undefined,
  newFormData,
) => {
  // Only sync if view:isPow exists
  if (!newFormData['view:isPow']) return newFormData;
  return reconcileDisabilityMap({
    oldFormData,
    newFormData,
    mapPath: 'view:isPow.powDisabilities',
    getDisabilities: fd =>
      getCurrentPOWDisabilityIdArray(fd).map(id => ({ id })),
    keyForDisability: d => d.id,
    preservedKeys: [],
    migrateRenames: true,
  });
};
